var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"order-history"}},[_c('b-card',{attrs:{"header-tag":"header"}},[_c('order-history-data',{attrs:{"sales_channel":_vm.sales_channel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }